import type { JSX } from 'react'
import type { IImagePoster } from 'atoms/ImagePoster'

import { FallbackImageSizes } from 'atoms/FallbackImage'
import { ImagePoster } from 'atoms/ImagePoster'
import { COLOR } from 'vars/index'
import { EpgPosterSC } from './EpgPoster.styled'

export const EpgPoster = ({
  posterUrl,
  fallbackImageBackground = COLOR.TRANSPARENT,
  fallbackImageColor = COLOR.TEXT_ICON_TERTIARY,
  fallbackImageSize = FallbackImageSizes.XS,
}: Pick<
  IImagePoster,
  | 'fallbackImageSize'
  | 'fallbackImageColor'
  | 'fallbackImageBackground'
  | 'posterUrl'
>): JSX.Element => {
  return (
    <EpgPosterSC>
      <ImagePoster
        posterUrl={posterUrl}
        fallbackImageBackground={fallbackImageBackground}
        fallbackImageColor={fallbackImageColor}
        fallbackImageSize={fallbackImageSize}
      />
    </EpgPosterSC>
  )
}
